module.exports = [
  {
    code: 'en',
    locale: 'en',
    name: 'English',
  },
  {
    code: 'bg',
    locale: 'bg',
    name: 'Български',
    default: true,
  },
]
